export const customPointStyle = (context: any) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx!.imageSmoothingEnabled = true;

    // Draw the colored circle
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 8;
    ctx!.beginPath();
    ctx!.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    ctx!.fillStyle = context.dataset.backgroundColor;
    ctx!.fill();

    // Add a border to the circle
    ctx!.strokeStyle = "#131314"; // Set the border color
    ctx!.lineWidth = 1; // Set the border width
    ctx!.stroke();

    if (context.dataset.data.length && context.dataset.data[context.dataIndex] && context.dataset.data[context.dataIndex].isSelected) {
        //Draw the selected circle
        ctx!.beginPath();
        ctx!.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx!.fillStyle = context.dataset.clubColor;
        ctx!.fill();


        // Draw the outer circle (border)
        ctx!.beginPath();
        ctx!.arc(centerX, centerY, 10, 0, 2 * Math.PI);
        ctx!.strokeStyle = "#FFFFFF";
        ctx!.lineWidth = 2; // Adjust border thickness as needed
        ctx!.stroke();
    }

    // if (context.dataset.data.length && context.dataset.data[context.dataIndex] && context.dataset.data[context.dataIndex].isFavorite) {
    //     // Draw the star
    //     const starRadius = 10;
    //     ctx!.beginPath();
    //     ctx!.moveTo(centerX, centerY);
    //     for (let i = 0; i < 6; i++) {
    //         ctx!.lineTo(
    //             centerX + Math.cos((i * 2 * Math.PI) / 5) * starRadius,
    //             centerY + Math.sin((i * 2 * Math.PI) / 5) * starRadius
    //         );
    //         ctx!.lineTo(
    //             centerX + Math.cos(((i + 0.5) * 2 * Math.PI) / 5) * (starRadius / 2),
    //             centerY + Math.sin(((i + 0.5) * 2 * Math.PI) / 5) * (starRadius / 2)
    //         );
    //     }
    //     ctx!.closePath();
    //     ctx!.fillStyle = "#131314";
    //     ctx!.fill();
    // } else {
    //     // Draw the text inside the circle
    //     const textColor = "#131314";
    //     const fontSize = "16px";
    //     const text = context.dataset.clubIcon || "";
    //     ctx!.fillStyle = textColor;
    //     ctx!.font = `bold ${fontSize} Davis Sans-Bold, Helvetica`;
    //     ctx!.textAlign = "center";
    //     ctx!.textBaseline = "middle";
    //     ctx!.fillText(text, centerX, centerY);
    // }
    return canvas;
}